export default [
  {
    title: "Administração",
    icon: "ToolIcon", // Alterado para representar o controle e gerenciamento
    children: [
      {
        title: "Visão Geral",
        route: "administrator-dashboard",
        icon: "LayoutIcon", // Mais alinhado com a visão geral do sistema
        action: "read",
        resource: "admin_dashboard",
      },
      {
        title: "Depósitos em Cripto",
        route: "crypto-deposits-list",
        icon: "CreditCardIcon", // Melhor para representar transações financeiras
        action: "read",
        resource: "admin_dashboard",
      },
      {
        title: "Crypto Withdrawal",
        route: "crypto-withdrawal-list",
        action: "read",
        resource: "admin_dashboard",
        icon: "TrendingUpIcon", // Mudança para ícone de transação (saques)
      },
      {
        title: "Lista de Usuários",
        route: "administrator-users-list",
        icon: "UserCheckIcon", // Representa a gestão e verificação de usuários
        action: "read",
        resource: "admin_dashboard",
      },
      {
        title: "Patrocínio",
        route: "add-remove-balance",
        icon: "GiftIcon", // Mantido, pois é adequado para representar recompensas e bonificações
        action: "read",
        resource: "admin_dashboard",
      },
      {
        title: "Graduations",
        route: "graduations",
        action: "read",
        resource: "admin_views",
        icon: "AwardIcon", // Ícone de prêmio ou medalha para representar graduações
      },
      {
        title: "Lista de Tickets",
        route: "customer-service-tickets-list",
        icon: "ClipboardIcon", // Representa melhor a gestão de tickets e documentos
        action: "read",
        resource: "admin_dashboard",
      },
    ],
  },
  {
    header: 'POOLS'
  },
  {
    title: "Nossos Pools",
    route: "dashboard-pools",
    icon: "DatabaseIcon", // Representa uma estrutura de dados, adequado para pools de liquidez
    action: "read",
    resource: "registered-user",
  },
  {
    title: "Meus Pools",
    route: "dashboard-my-results",
    icon: "BarChartIcon", // Representa melhor o acompanhamento de resultados
    action: "read",
    resource: "registered-user",
  },
  {
    header: 'PLANOS'
  },
  {
    title: "Pacotes",
    route: "licenses",
    icon: "PackageIcon", // Representa pacotes ou produtos financeiros
    action: "read",
    resource: "registered-user",
  },
  {
    title: "Meus Planos",
    route: "in-operation",
    icon: "TrendingUpIcon", // Representa crescimento e operação em andamento
    action: "read",
    resource: "registered-user",
  },
  {
    header: 'FINANCIAL',
  },
  {
    title: "Deposits",
    route: "wallet-my-deposits",
    action: "read",
    icon: "ArrowDownCircleIcon",
    resource: "registered-user",
  },
  {
    title: "Withdrawals",
    route: "wallet-my-withdrawals",
    action: "read",
    icon: "ArrowUpCircleIcon",
    resource: "registered-user",
  },
  {
    header: 'TOKEN'
  },
  {
    title: "Smartby Coin",
    route: "token-analytics",
    icon: "DollarSignIcon", // Mantido, pois representa bem análise de valor do token
    action: "read",
    resource: "registered-user",
  },
  {
    header: 'AFILIADOS'
  },
  {
    title: "Afiliados",
    route: "affiliate-network-dashboard",
    icon: "UsersIcon", // Mantido, pois representa a rede de afiliados
    action: "read",
    resource: "registered-user",
  },
  {
    title: "Lista de Afiliados",
    route: "affiliate-network-direct-references",
    icon: "UserPlusIcon", // Mantido, pois simboliza bem a adição de referências diretas
    action: "read",
    resource: "registered-user",
  },
  {
    header: 'SUPORTE'
  },
  {
    title: "Suporte",
    route: "support",
    tag: "Ticket",
    tagVariant: "light-info",
    icon: "LifeBuoyIcon", // Alterado para representar ajuda e suporte
    action: "read",
    resource: "registered-user",
  },
];
